import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'newLine'
})
export class NewLinePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    try {
      if (value) {
        return value.replace(/\n/g, '<br/>');
      } else {
        return '';
      }
    } catch (ex) {
      return '';
    }
  }

}